module.exports = __webpack_public_path__ + "static/media/Sophie_respirar.f90fbabc.jpg";